<template>
  <div class="RFQ-detail">
    <content-block style="padding-bottom: 0;">
      <div class="detail-box">
        <img :src="require('@/assets/imgs/ic_document_2.svg')" class="detail-pic" />
        <div class="detail-title">
          <b>询单号：{{ detail.code || '--' }}</b>
          <span>{{ `${detail.inquirePriceParty}_${detail.businessTypeDesc}_${detail.code}` || '--' }}</span>
        </div>
        <el-tooltip content="单据状态" placement="top-end">
          <img :src="detail.statusImage" class="status-image" />
        </el-tooltip>
        <el-tooltip v-show="detail.status === 'FINISHED'" :content="`${detail.closeTypeDesc}${detail.closeReason ? '：' + detail.closeReason : ''}`" placement="top-end">
          <img :src="require('@/assets/imgs/icon_tip.svg')" />
        </el-tooltip>
        <div class="line"></div>
        <el-tooltip content="接单状态" placement="top-end">
          <div :class="['detail-status', getStatusColor(detail.taskOrderStatus)]">{{ `供应商${detail.taskOrderStatusDesc}` }}</div>
        </el-tooltip>
        <div class="line"></div>
        <el-tooltip content="报价状态" placement="top-end">
          <div :class="['detail-status', getStatusColor(detail.quotePriceStatus)]">{{ `供应商${detail.quotePriceStatusDesc}` }}</div>
        </el-tooltip>
        <el-image v-if="detail.emergencyLevel" :src="getEmergencyLevel()" class="emergency-level" />
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="询价信息" name="inquiry"/>
        <el-tab-pane label="报价信息" name="quotation"/>
        <el-tab-pane label="履约信息" name="performance"/>
        <el-tab-pane label="日志动态" name="logs"/>
      </el-tabs>
    </content-block>
    <content-block style="padding: 0;">
      <!-- 询价信息 -->
      <inquiryDetail v-if="activeName === 'inquiry' && id" :inquiryId="id" />
      <!-- 报价信息 -->
      <quotationDetail v-if="activeName === 'quotation' && id" :inquirePriceId="id" :businessType="detail.businessType" :status="detail.status" :quotePriceStatus="detail.quotePriceStatus" :zgyFlag="detail.zgyFlag" />
      <!-- 履约信息 -->
      <div v-if="activeName === 'performance' && id">
        <PerformanceInfomation :code="detail.code" :cooperationLedgerId="detail.cooperationLedgerId"></PerformanceInfomation>
      </div>
      <!-- 日志动态 -->
      <div v-if="activeName === 'logs'">
        <logs :id="id" />
      </div>
    </content-block>
  </div>
</template>
<script>
import { getDetailByInquiry } from '@/api/RFQ';
import inquiryDetail from './component/inquiryDetail.vue';
import quotationDetail from './component/quotationDetail.vue';
import logs from './component/logs.vue';
import PerformanceInfomation from './component/performanceInformation';
export default {
  components: {
    inquiryDetail,
    quotationDetail,
    logs,
    PerformanceInfomation,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      emptyIcon: require('@/assets/imgs/default.svg'), // eslint-disable-line
      activeName: null,
      id: '',
      detail: {},
    };
  },
  watch: {
    id (v) {
      v && this.refresh();
    },
  },
  methods: {
    handleClick () {
    },
    getStatusColor (v) {
      const blue = ['PART_TASK_ORDER', 'PART_QUOTE_PRICE'];
      const green = ['ALL_QUOTE_PRICE', 'ALL_TASK_ORDER'];
      const orange = ['NOT_TASK_ORDER', 'NOT_QUOTE_PRICE', 'NOT'];
      const grey = ['CLOSED'];
      if (blue.includes(v)) return 'blue';
      if (green.includes(v)) return 'green';
      if (orange.includes(v)) return 'orange';
      if (grey.includes(v)) return 'grey';
      return 'grey';
    },
    getEmergencyLevel () {
      if (this.detail.emergencyLevel === 'HIGH') {
        return require('@/assets/imgs/ic_high.svg'); // eslint-disable-line
      }
      if (this.detail.emergencyLevel === 'MEDIUM') {
        return require('@/assets/imgs/ic_medium.svg'); // eslint-disable-line
      }
      if (this.detail.emergencyLevel === 'LOW') {
        return require('@/assets/imgs/ic_low.svg'); // eslint-disable-line
      }
      return null;
    },
    async getRFQDetail () {
      const { body } = await getDetailByInquiry({ id: this.id });
      this.detail = { ...this.detail, ...body };
      this.detail.statusImage = require(`@/assets/imgs/RFQ/ic_${this.detail.status.toLowerCase()}.svg`); // eslint-disable-line
      if (this.$route.query.deal === 'yes') {
        this.activeName = 'quotation';
      } else {
        this.activeName = 'inquiry';
      }
    },
    refresh (params) {
      if (params?.closed) {
        this.detail.status = 'FINISHED';
      }
      this.getRFQDetail();
    },
  },
  mounted () {
    this.id = this.params.id;
    this.detail = this.params || {};
  },
};
</script>
<style lang="scss" scoped>
.RFQ-detail {
  /deep/.el-tabs__header {
    margin-bottom: 0;
    padding-left: 15px;
    padding-right: 15px;
  }
  .detail-box {
    display: flex;
    align-items: center;
    padding: 8px;
    .detail-pic {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }
    .detail-title {
      font-size: 14px;
      color: #303133;
      display: inline-flex;
      flex-direction: column;
      margin-right: 10px;
    }
    .status-image {
      margin: 0 5px;
    }
    .line {
      display: inline-block;
      height: 20px;
      width: 2px;
      background-color: #eeeeee;
      margin: 0 5px;
    }
    .emergency-level {
      margin: 0 10px;
    }
    .detail-status {
      font-weight: 400;
      font-size: 12px;
      border-radius: 4px;
      padding: 4px 6px;
      margin-left: 15px;
      margin-right: 10px;
      &.green {
        color: #21CE6E;
        background: #E5FEEB;
      }
      &.blue {
        color: #2A82FA;
        background: #E2F3FE;
      }
      &.orange {
        color: #FAB10A;
        background: #FDFADF;
      }
      &.grey {
        color: #1F2733;
        background: #F2F4F7;
      }
    }
  }
}
</style>
